import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import classSet from 'react-classset';
import MainMenu from '../MainMenu/MainMenu';
const logoImg = process.env.REACT_APP_IMAGES_ROOT + 'logo.png';
const menuIcon = process.env.REACT_APP_IMAGES_ROOT + 'menu.svg';

class Header extends Component {
  constructor() {
    super();
    this.state = {
      showMenu: null
    };
    this.toggleMenu = this.toggleMenu.bind(this);
    this.handleKeypress = this.handleKeypress.bind(this);
  }

  componentDidMount() {
    window.addEventListener('keydown', this.handleKeypress);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeypress);
  }

  handleKeypress(e) {
    if (e.keyCode === 27 && this.state.showMenu) {
      this.setState({showMenu: false});
    }
  }

  toggleMenu() {
    this.setState({showMenu: !this.state.showMenu});
  }

  render() {
    const headerClasses = classSet({
      'ssc__header--main': true,
      'ssc__header--main--showing-menu': this.state.showMenu
    });

    return (

      <div className={headerClasses}>

        <div className="ssc__header--main__banner">
          <Link to="/">
            <img className="ssc__header--main__logo" src={logoImg} alt="logo" />
          </Link>
          <img className="ssc__header--main__menu-toggle" onClick={this.toggleMenu} src={menuIcon} alt="open menu" />
        </div>

        {this.state.showMenu &&
          <MainMenu appHeight={this.props.appHeight} shopUrl={this.props.shopUrl} closeMenu={this.toggleMenu} />
        }

      </div>

    );

  }

}

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header/Header.js